import React from "react";
import "./styles/loader.css";

export default () => <div className="loader" />;